import { Component, OnInit, ViewChild, ElementRef, forwardRef, Output, Input, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-stripe-elements-form',
  templateUrl: './stripe-elements-form.component.html',
  styleUrls: ['./stripe-elements-form.component.scss']
})
export class StripeElementsFormComponent implements OnInit {

  @ViewChild('cardElement', { static: true }) cardElement: ElementRef;

  @Input() stripe: stripe.Stripe;
  @Output() cardCreated = new EventEmitter();
  @Output() elementEmpty = new EventEmitter();

  @Input() type: 'cccard' | 'sepa' = 'cccard';

  public card;
  public iban;
  public cardErrors;
  public confirmation;

  constructor(private translate: TranslateService) { }

  ngOnInit() {

    const style = {
      'style': {
        'base': {
          fontFamily: '"Muli", sans-serif',
          fontSize: '13px',
          fontWeight: '600',
          color: '#495057',
          '::placeholder': {
            color: '#6c757d'
          },
        },
        'invalid': {
          'color': '#EB5C5C',
        },
      }
    };


    const elements = this.stripe.elements({
      locale: this.translate.currentLang, // pt not yet supported https://stripe.com/docs/stripe-js/reference#the-stripe-object
      fonts: [
        {
          cssSrc: 'https://fonts.googleapis.com/css?family=Muli:300,400,600,700,800,900'
        }
      ],
    });

    if (this.type === 'sepa') {
      this.setUpDirectDebit(elements, style);
    } else if (this.type === 'cccard') {
      this.setUpCard(elements, style)
    }

  }

  setUpCard(elements, style) {
    this.card = elements.create('card', style);
    this.card.mount(this.cardElement.nativeElement);
    this.elementEmpty.emit(true);
    this.card.addEventListener('change', ( data ) => {
      this.elementEmpty.emit(data.empty);
      this.cardErrors = data.error && data.error.message;
    });

    this.cardCreated.emit(this.card);
  }

  setUpDirectDebit(elements, style) {
    const options = {
      style,
      supportedCountries: ['SEPA'],
      // Elements can use a placeholder as an example IBAN that reflects
      // the IBAN format of your customer's country. If you know your
      // customer's country, we recommend passing it to the Element as the
      // placeholderCountry.
      placeholderCountry: 'PT',
    };

    this.iban = elements.create('iban', options);
    this.iban.mount(this.cardElement.nativeElement);
    this.elementEmpty.emit(true);
    this.iban.addEventListener('change', (data) => {
      this.elementEmpty.emit(data.empty);
      this.cardErrors = data.error && data.error.message;
    });

    this.cardCreated.emit(this.iban);
  }


}
